var _style, _path, _path2, _path3, _line, _line2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .waste-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:10;stroke-miterlimit:10;}\r\n        .waste-st1{fill:none;stroke:currentColor;stroke-width:10;stroke-miterlimit:10;}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "waste-st0",
    d: "M28.5,34.5V342l57-53.5h188l58,53.5V33.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "waste-st0",
    d: "M331.5,288.5c-36,0-58,0-58,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "waste-st0",
    d: "M288.5,323.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "waste-st1",
    x1: 28.5,
    y1: 288.5,
    x2: 85.5,
    y2: 288.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "waste-st0",
    x1: 7.2,
    y1: 31.2,
    x2: 352.8,
    y2: 31.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "waste-st1",
    d: "M148.1,29c0-10.6,14.3-19.1,31.9-19.1s31.9,8.6,31.9,19.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaste);
export default __webpack_public_path__ + "static/media/waste.91517704e5251f883559399fa8d0b526.svg";
export { ForwardRef as ReactComponent };